var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "type-icon" }, [
      _vm.dataDetail.trigger.type === "form"
        ? _c("img", {
            attrs: {
              src: require("@/assets/automation/data_manager.svg"),
              width: "62",
              height: "62"
            }
          })
        : _vm.dataDetail.trigger.type === "event"
        ? _c("img", {
            attrs: {
              src: require("@/assets/automation/event.svg"),
              width: "62",
              height: "62"
            }
          })
        : _vm.dataDetail.trigger.type === "function"
        ? _c("img", {
            attrs: {
              src: require("@/assets/automation/function.svg"),
              width: "62",
              height: "62"
            }
          })
        : _vm.dataDetail.trigger.type === "job" ||
          _vm.dataDetail.trigger.type === "dedicated_job"
        ? _c("img", {
            attrs: {
              src: require("@/assets/automation/job.svg"),
              width: "62",
              height: "62"
            }
          })
        : _c("img", {
            attrs: {
              src: require("@/assets/automation/api.svg"),
              width: "62",
              height: "62"
            }
          })
    ]),
    _vm._v(" "),
    _c(
      "button",
      {
        staticClass: "btn-open-tab",
        attrs: { type: "button" },
        on: { click: _vm.handleOpenNewTab }
      },
      [
        _c("img", {
          attrs: {
            src: require("@/assets/icon/foldering/open.svg"),
            width: "16",
            height: "16",
            alt: "open-tab-icon"
          }
        }),
        _vm._v("\n    Open\n  ")
      ]
    ),
    _vm._v(" "),
    _c("section", [
      _c("p", { staticClass: "title-section" }, [_vm._v("Who Has Access")]),
      _vm._v(" "),
      _c("div", { staticClass: "d-flex" }, [
        _vm.profile_data && _vm.profile_data.photo_url
          ? _c("img", {
              staticClass: "profile-pic-access",
              attrs: {
                src: _vm.profile_data.photo_url,
                width: "42",
                height: "42",
                alt: "profile-pic-access"
              }
            })
          : _c(
              "div",
              {
                staticClass: "initial-access",
                style: "background-color: " + _vm.bg_initial_profile
              },
              [_vm._v("\n        " + _vm._s(_vm.initialName) + "\n      ")]
            ),
        _vm._v(" "),
        _c("div", { staticClass: "access-name" }, [_vm._v("Anyone")])
      ])
    ]),
    _vm._v(" "),
    _c("section", [
      _c("p", { staticClass: "title-section" }, [_vm._v("System Properties")]),
      _vm._v(" "),
      _c("div", { staticClass: "list-properties" }, [
        _c("p", { staticClass: "properties-title" }, [_vm._v("Type")]),
        _vm._v(" "),
        _c("p", { staticClass: "properties-detail" }, [
          _vm._v("\n        " + _vm._s(_vm.propertiesType) + "\n        "),
          _c("span", { domProps: { innerHTML: _vm._s(_vm.propertiesEvent) } })
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "list-properties" }, [
        _c("p", { staticClass: "properties-title" }, [
          _vm._v(_vm._s(_vm.sourceTitle))
        ]),
        _vm._v(" "),
        _vm.dataDetail.trigger.type === "form"
          ? _c(
              "div",
              {
                staticClass:
                  "d-flex flex-wrap align-items-center properties-source"
              },
              [
                _vm.tableGroupname
                  ? _c(
                      "span",
                      { staticStyle: { "text-transform": "lowercase" } },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.tableGroupname) +
                            "\n        "
                        )
                      ]
                    )
                  : _c("span", { staticClass: "skeleton-desc" }),
                _vm._v(" "),
                _c("i", { staticClass: "fa fa-caret-right mx-2 caret-icon" }),
                _vm._v("\n        " + _vm._s(_vm.propertiesSource) + "\n      ")
              ]
            )
          : _c(
              "div",
              {
                staticClass: "properties-source",
                class: {
                  "properties-url":
                    _vm.dataDetail.trigger.type.includes("api") ||
                    _vm.dataDetail.trigger.type.includes("webhook")
                }
              },
              [
                _vm._v(
                  "\n        " + _vm._s(_vm.propertiesSource) + "\n        "
                ),
                _vm.propertiesSource &&
                (_vm.dataDetail.trigger.type.includes("api") ||
                  _vm.dataDetail.trigger.type.includes("webhook"))
                  ? _c("i", {
                      staticClass: "fa fa-clone clone-icon",
                      on: { click: _vm.copyToClipboard }
                    })
                  : _vm._e()
              ]
            )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "list-properties" }, [
        _c("p", { staticClass: "properties-title" }, [_vm._v("Status")]),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "status",
            class: _vm.dataDetail.is_active ? "status-on" : "status-off"
          },
          [
            _c("div", { staticClass: "circle-accent" }),
            _vm._v(" "),
            _c("span", [
              _vm._v(_vm._s(_vm.dataDetail.is_active ? "ON" : "OFF"))
            ])
          ]
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "list-properties" }, [
        _c("p", { staticClass: "properties-title" }, [_vm._v("Description")]),
        _vm._v(" "),
        _c("p", { staticClass: "properties-desc" }, [
          _vm._v(_vm._s(_vm.dataDetail.description || "-"))
        ])
      ]),
      _vm._v(" "),
      _vm._m(0),
      _vm._v(" "),
      _vm._m(1),
      _vm._v(" "),
      _c("div", { staticClass: "list-properties" }, [
        _c("p", { staticClass: "properties-title" }, [_vm._v("Modified By")]),
        _vm._v(" "),
        _c("div", { staticClass: "created-by" }, [
          _vm.dataDetail.updated_by_person.photo
            ? _c("img", {
                staticClass: "round-bordered-img",
                attrs: {
                  src: _vm.dataDetail.updated_by_person.photo,
                  rounded: "circle",
                  alt: "img"
                }
              })
            : _c("img", {
                staticClass: "round-bordered-img",
                attrs: { src: require("@/assets/logo/user1.png"), alt: "img" }
              }),
          _vm._v(" "),
          _c("div", [
            _c("div", { staticClass: "email" }, [
              _vm._v(_vm._s(_vm.dataDetail.updated_by_person.email))
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "name" }, [
              _vm._v(
                _vm._s(_vm.dataDetail.updated_by_person.first_name) +
                  " " +
                  _vm._s(_vm.dataDetail.updated_by_person.last_name)
              )
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "list-properties" }, [
        _c("p", { staticClass: "properties-title" }, [_vm._v("Modified at")]),
        _vm._v(" "),
        _c("p", { staticClass: "properties-detail" }, [
          _vm._v(_vm._s(_vm.convertDateTime(_vm.dataDetail.updated_at)))
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "list-properties" }, [
        _c("p", { staticClass: "properties-title" }, [_vm._v("Created By")]),
        _vm._v(" "),
        _c("div", { staticClass: "created-by" }, [
          _vm.dataDetail.created_by_person.photo
            ? _c("img", {
                staticClass: "round-bordered-img",
                attrs: {
                  src: _vm.dataDetail.created_by_person.photo,
                  rounded: "circle",
                  alt: "img"
                }
              })
            : _c("img", {
                staticClass: "round-bordered-img",
                attrs: { src: require("@/assets/logo/user1.png"), alt: "img" }
              }),
          _vm._v(" "),
          _c("div", [
            _c("div", { staticClass: "email" }, [
              _vm._v(_vm._s(_vm.dataDetail.created_by_person.email))
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "name" }, [
              _vm._v(
                _vm._s(_vm.dataDetail.created_by_person.first_name) +
                  " " +
                  _vm._s(_vm.dataDetail.created_by_person.last_name)
              )
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "list-properties" }, [
        _c("p", { staticClass: "properties-title" }, [_vm._v("Created at")]),
        _vm._v(" "),
        _c("p", { staticClass: "properties-detail" }, [
          _vm._v(_vm._s(_vm.convertDateTime(_vm.dataDetail.created_at)))
        ])
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "list-properties" }, [
      _c("p", { staticClass: "properties-title" }, [_vm._v("Location")]),
      _vm._v(" "),
      _c("p", { staticClass: "properties-detail" }, [
        _vm._v("Visual Programming")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "list-properties" }, [
      _c("p", { staticClass: "properties-title" }, [_vm._v("Owner")]),
      _vm._v(" "),
      _c("p", { staticClass: "properties-detail" }, [_vm._v("Me")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-87eb667e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-87eb667e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/visual-programming/popup/partials/jPopupDetailTab.vue
// module id = null
// module chunks = 